// helper to get/construct asset source for uploaded builder assets
export default function getAssetSource(src: string = '') {
  if (src === '') return '';

  return src?.startsWith('http')
    ? src
    : `${__ASSETS_COMMON_IMAGES_URL__}${src?.startsWith('/') ? '' : '/'}${src}`;
}
